import React from 'react';
import { EventSeriesLink } from '../constants';
import './DataCenterWorldFooterEventSeries.scss';

interface DataCenterWorldFooterEventSeriesProps {
  events: EventSeriesLink[];
}

export default function DataCenterWorldFooterEventSeries({
  events,
}: DataCenterWorldFooterEventSeriesProps) {
  return (
    <nav
      className="c-dcw-footer-event-series"
      data-testid="dcw-footer-event-series"
    >
      <h3 className="c-dcw-footer-event-series__heading">
        Global Event Series
      </h3>
      <ul>
        {events.map(({ id, name, href }) => (
          <li key={id}>
            <a href={href} target="_blank" rel="noopener noreferrer">
              {name}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
